export enum MessageContentType {
  TEXT = 'TEXT',
  JSON = 'JSON',
  ARGOS_EVENT = 'ARGOS_EVENT',
}
